import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { ServiceApi } from "../services/index.service";
import MandatoryPromotions from "./MandatoryPromotions";
import NonMandatoryPromotions from "./NonMandatoryPromotions";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import AddPromotionDialog from "./AddPromotionDialog";
import dayjs from "dayjs";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const DriveThruPreSellBoardAdmin = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [btnloading, setBtnLoading] = useState(false);
  const [mandatoryList, setMandatoryList] = useState([]);
  const [nonMandatoryList, setNonMandatoryList] = useState([]);
  const initival = {
    intBannerID: 0,
    vchBannerName: "",
    vchBannerURL: "",
    bitActive: 0,
    bitMandatory: 0,
    dteStartDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    dteEndDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    bitBannerType: 1,
    dteDateCreated: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    bitVertical: 1,
  };
  const [selectedPromotion, setSelectedPromotion] = useState(initival);
  const [action, setAction] = useState("Add");
  const [showDialog, setShowDialog] = useState(false);
  const data = useSelector((state) => state);

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedPromotion(initival);
    setAction("Add");
  };

  const handleEdit = (dataItem) => {
    setAction("Update");
    setSelectedPromotion(dataItem);
    setShowDialog(true);
  };
  const handleDelete = async (dataItem) => {
    let req = {
      intBannerID: dataItem?.intBannerID,
      action:'delete',
      vchBannerName:dataItem?.vchBannerName,
      vchBannerURL:dataItem?.vchBannerURL
    };
    setBtnLoading(true);
    const res = await serviceapi.savePresellBoardAdmin(req);
    setBtnLoading(false);
    if (res?.success) {
      const message = "Promotion Deleted Successfully";
      setSelectedPromotion(initival);
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
      fetchPresellOrderList();
    } else {
      const message = "Error in Deleting Promotion";
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    }
  };
  const serviceapi = new ServiceApi();

  useEffect(() => {
    fetchPresellOrderList();
  }, [props?.success]);

  const fetchPresellOrderList = async () => {
    const req = {
      role: data?.profile?.role,
      user_name: data?.profile?.user_name,
      bitBannerType: 1,
    };
    setLoading(true);
    const res = await serviceapi.fetchPresellOrderList(req);
    setLoading(false);
    const result = res?.data;
    setMandatoryList(result?.mandatory);
    setNonMandatoryList(result?.nonMandatory);
  };

  const handlePromotion = (value, name) => {
    if (name === "Mandatory" && !value) {
      setSelectedPromotion({
        ...selectedPromotion,
        [name]: value,
        dteStartDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        dteEndDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      });
    } else if (name === "bitBannerType") {
      setSelectedPromotion({ ...selectedPromotion, [name]: value });
    } else {
      setSelectedPromotion({ ...selectedPromotion, [name]: value });
    }
  };

  const onSubmit = async () => {
    console.log(selectedPromotion);
    let req = {
      ...selectedPromotion,
      vchBannerName: selectedPromotion?.vchBannerName,
      vchBannerURL: selectedPromotion?.vchBannerURL,
      bitActive: selectedPromotion?.bitActive ? 1 : 0,
      bitMandatory: selectedPromotion?.bitMandatory ? 1 : 0,
      dteStartDate: selectedPromotion?.bitMandatory
        ? dayjs(selectedPromotion?.dteStartDate).format('YYYY-MM-DD HH:mm:ss')
        : dayjs().format('YYYY-MM-DD HH:mm:ss'),
      dteEndDate: selectedPromotion?.bitMandatory
        ? dayjs(selectedPromotion?.dteEndDate).format('YYYY-MM-DD HH:mm:ss')
        : dayjs().format('YYYY-MM-DD HH:mm:ss'),
      bitBannerType: 1,
      bitVertical: selectedPromotion?.bitVertical ? 1 : 0,
    };
    if (action === "Add") {
      req = { ...req, intBannerID: 0 };
    }
    setBtnLoading(true);
    const res = await serviceapi.savePresellBoardAdmin(req);
    console.log(res);
    setBtnLoading(false);
    if (res?.success) {
      let message = "Promotion Added Successfully";
      if (action === "Update") {
        message = "Promotion Updated Successfully";
      }
      setShowDialog(false);
      setSelectedPromotion(initival);
      fetchPresellOrderList();
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
    } else {
      let message = "Error in Adding Promotion";
      if (action === "Update") {
        message = "Error in Updating Promotion";
      }
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    }
  };

  const tabsList = [
    {
      id: 1,
      title: "Mandatory",
      label: "Mandatory",
      disabled: false,
    },
    {
      id: 2,
      label: "Non-Mandatory",
      title: "Non-Mandatory",
      disabled: false,
    },
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleUpdateOrder = async (list) => {
    console.log(list);
    const req = {body:list};
    setBtnLoading(true)
    const res = await serviceapi.savePresellBoardOrder(req);
    setBtnLoading(false)
    console.log(res);
    if (res?.success) {
      const message = "Order Updated Successfully";
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
      fetchPresellOrderList();
    } else {
      const message = "Error in  updating order";
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
      fetchPresellOrderList();
    }
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading || btnloading}
        onClick={handleCloseDialog}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <main>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handleChange}>
            {tabsList?.map((itm, index) => (
              <Tab
                label={itm.label}
                {...a11yProps(itm.id)}
                key={itm.id}
                disabled={itm.disabled}
              />
            ))}
          </Tabs>
        </Box>
        {tabsList?.map((tabItem, index) => {
          return (
            <TabPanel key={tabItem.id} value={value} index={index}>
              {tabItem.id === 1 && (
                <MandatoryPromotions
                  loading={loading}
                  IsAdmin={true}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  promotionsList={mandatoryList}
                  handleUpdateOrder={handleUpdateOrder}
                />
              )}
              {tabItem.id === 2 && (
                <NonMandatoryPromotions
                  loading={loading}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  IsAdmin={true}
                  promotionsList={nonMandatoryList}
                  handleUpdateOrder={handleUpdateOrder}
                />
              )}
            </TabPanel>
          );
        })}
      </main>
      {showDialog ? (
        <AddPromotionDialog
          showDialog={showDialog}
          handleCloseDialog={handleCloseDialog}
          action={action}
          IsAdmin={true}
          selectedPromotion={selectedPromotion}
          handlePromotion={handlePromotion}
          btnloading={btnloading}
          onSubmit={onSubmit}
          setSelectedPromotion={setSelectedPromotion}
        />
      ) : null}
    </>
  );
};

export default DriveThruPreSellBoardAdmin;
